import { RefObject, useEffect, useState } from 'react';
import PrismLight from 'react-syntax-highlighter/dist/cjs/prism-light';

const SyntaxHighlighter = PrismLight;

export interface IArticleIndex {
  title: string;
  id: string;
}

export const getArticleId = (title: string): string => {
  const articleWords = title?.toLowerCase().split(' ');
  const articleId = articleWords?.join('-').trim();
  return articleId;
};

export function createArticleIndex(): IArticleIndex[] {
  const h2Tags = document.getElementsByTagName('h2');
  return h2Tags?.length
    ? [...Array(h2Tags.length)].map((_, h2) => ({
        title: h2Tags.item(h2)?.innerText ?? '',
        id: h2Tags.item(h2)?.id ?? '',
      }))
    : [];
}

export function transformPostBody(content: RefObject<HTMLDivElement>): string {
  const template: HTMLDivElement = document.createElement('div');
  template.innerHTML = content.current?.innerHTML ?? '';

  const h2Tags = template.getElementsByTagName('h2');
  for (let i = 0; i < h2Tags.length; i += 1) {
    const articleId = getArticleId(h2Tags[i].innerText);
    h2Tags[i].setAttribute('id', articleId);
    const parent = h2Tags[i].parentNode;
    parent?.replaceChild(template.getElementsByTagName('h2')[i], h2Tags[i]);
  }

  return template.innerHTML;
}

const htmlCodeSplitter = (html: string) => html.split(/<pre[^>]*><code[^>]*>[\s\S]*?<\/code><\/pre>/);

export function useSyntaxHighlighter({ formattedArticleContents }: { formattedArticleContents: string }) {
  const [htmlSections, setHtmlSections] = useState<string[]>([]);
  const [codeSections, setCodeSections] = useState<{ code: string; language: string }[]>([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const articleTemplate = document.createElement('div');
    articleTemplate.innerHTML = formattedArticleContents;

    if (articleTemplate) {
      const codeNodes = Array.from(articleTemplate.querySelectorAll('pre code'));
      const languages = new Set<string>();
      setCodeSections(
        codeNodes.map((node) => {
          const language = node.className.match(/language-([^\s'"]*)/)?.[1] ?? '';
          if (language) {
            languages.add(language);
          }
          return {
            code: node.textContent ?? '',
            language,
          };
        }),
      );
      setLoaded(languages.size === 0);
      // TODO: Import in a way that doesn't add all languages to the bundle
      // Promise.all(
      //   Array.from(languages).map((language) =>
      //     import(`react-syntax-highlighter/dist/cjs/languages/prism/${language}`).then((lang) => {
      //       SyntaxHighlighter.registerLanguage(language, lang.default);
      //     }),
      //   ),
      // ).finally(() => {
      //   setLoaded(true);
      // });
    }
    setHtmlSections(htmlCodeSplitter(formattedArticleContents));
  }, [formattedArticleContents]);

  return {
    htmlSections,
    codeSections,
    loaded,
    SyntaxHighlighter,
  };
}
